import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog';
import { ErrorContent } from './widgets';

interface Props {
  error: Error;
  helpMsg?: string;
  dialogProps?: DialogProps;
}

export const ErrorPage = ({ dialogProps, ...rest }: Props) => {
  if (!dialogProps) return <ErrorContent {...rest} />;

  const { open, onClose } = dialogProps;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Error</DialogTitle>
      <DialogContent>
        <ErrorContent {...rest} />
      </DialogContent>
    </Dialog>
  );
};
